import { em, rem } from 'polished'
import styled, { css } from 'styled-components'

export interface IBaseStepCountStepStyledProps {
  clickable?: boolean
}

export const BaseStepCountStepStyled = styled.li<IBaseStepCountStepStyledProps>`
  font-size: ${rem(16)};

  width: ${em(10)};
  height: ${em(10)};

  display: inline-block;

  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.lightGrey};

  transition: background-color 0.3s ease;

  ${(props) => {
    if (props.clickable) {
      return css`
        cursor: pointer;
      `
    }
  }}

  & + li {
    margin-left: ${em(6)};
  }
`
